/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

const CookiePolicy = () => (
  <div className="container">
    <div style={{ fontSize: '30px', marginBottom: '10px', fontFamily: 'gt_walsheim' }}>
      Use of cookies on
      <span>&nbsp;Marketplace</span>
    </div>
    <div style={{
      fontSize: '20px',
      marginBottom: '10px',
      fontFamily: 'gt_walsheim',
      textDecoration: 'underline',
    }}
    >
      Cookie Policy
    </div>
    <p className="medium-text space-bottom-double" style={{ marginBottom: '10px' }}>
      This policy
      <b>
        &nbsp;(“Cookie Policy”)&nbsp;
      </b>
      sets out information about Travelport’s
      <b>
        &nbsp;(“Travelport,” “we,” “us,” “our”)&nbsp;
      </b>
      use of cookies on our website at travelportmarketplace.com
      <b>
        &nbsp;(“Website”)&nbsp;
      </b>
      . It explains what cookies are and why we use them, as well as your rights to control our use of them.
    </p>
    <div style={{ fontSize: '20px', marginBottom: '10px', fontFamily: 'gt_walsheim' }}>What is a cookie?</div>
    <p className="medium-text space-bottom-double" style={{ marginBottom: '10px' }}>
      A ‘cookie’ is a small data file that is stored on your device when you visit a website or perform actions while visiting a website.
    </p>
    <p className="medium-text space-bottom-double" style={{ marginBottom: '10px' }}>
      Cookies may be set by the website you are visiting
      <b>
        &nbsp;("first-party cookies")&nbsp;
      </b>
      or may be set by other websites who display content on the page you are viewing
      <b>
        &nbsp;("third-party cookies")&nbsp;
      </b>
      . Third-party cookies enable third-party features or functionality to be provided on or through the website you are visiting (e.g., advertising, interactive content or analytics).
      The cookies placed by the Website are all first-party cookies.
    </p>
    <p className="medium-text space-bottom-double" style={{ marginBottom: '10px' }}>
      Cookies can be useful because they allow a website to recognize a user’s device.
      They are widely used to make websites work, or work more efficiently, as well as to provide information to the owners of the site.
    </p>
    <div style={{ fontSize: '20px', marginBottom: '10px', fontFamily: 'gt_walsheim' }}>What cookies does Travelport use and why?</div>
    <div style={{ fontSize: '20px', marginBottom: '10px', fontFamily: 'gt_walsheim' }}>Strictly Necessary Cookies</div>
    <p className="medium-text space-bottom-double" style={{ marginBottom: '10px' }}>
      This Website utilizes strictly necessary cookies that are required for basic website operation, such as to allow page navigation or site access, or to set up essential functionalities to guarantee the security and efficiency of our Website. This Website cannot function properly without these cookies. If these cookies are blocked or disabled by amending your browser settings, our Website may cease to function properly and users may experience reduced or limited functionality.  We do not accept any liability for any loss arising where strictly necessary cookies are blocked.
    </p>
    <p className="medium-text space-bottom-double" style={{ marginBottom: '10px' }}>
      We also utilize non-necessary cookies.  These cookies are used by Travelport for analytical purposes and for website performance improvement and help us provide the best user experience. These cookies are detailed below.
    </p>
    <div style={{ fontSize: '20px', marginBottom: '10px', fontFamily: 'gt_walsheim' }}>Analytical / Performance cookies</div>
    <p className="medium-text space-bottom-double" style={{ marginBottom: '10px' }}>
      Analytical or performance cookies are used to collect information about how users interact with our Website and are used to improve the Website performance and user experience. For example, we may use these cookies to count page visits, how much time a user has spent on our Website, count errors on damaged websites, or count traffic sources so we can measure and improve the performance of our Website.
    </p>
    <div style={{ fontSize: '20px', marginBottom: '10px', fontFamily: 'gt_walsheim' }}>How can I manage the use of cookies?</div>
    <p className="medium-text space-bottom-double" style={{ marginBottom: '10px' }}>
      When you visit our Website, you will be prompted via our cookie banner to accept or refuse cookies. You can either accept or reject all cookies. Strictly necessary cookies cannot be rejected as they are essential to provide you with the services the Website provides.
    </p>
    <p className="medium-text space-bottom-double" style={{ marginBottom: '10px' }}>
      If you choose to reject cookies, you may still use our Website but your access to some functionality and areas of the Website may be restricted.
    </p>
    <div style={{ fontSize: '20px', marginBottom: '10px', fontFamily: 'gt_walsheim' }}>Removing cookies from your device</div>
    <p className="medium-text space-bottom-double" style={{ marginBottom: '10px' }}>
      You can also delete all cookies that are already on your device by clearing the browsing history of your browser. This will remove all cookies from all websites you have visited. Be aware that by deleting cookies in this way you may also lose some saved information (e.g. saved login details, site preferences).
    </p>
    <div style={{ fontSize: '20px', marginBottom: '10px', fontFamily: 'gt_walsheim' }}>Blocking cookies</div>
    <p className="medium-text space-bottom-double" style={{ marginBottom: '10px' }}>
      You can set most modern browsers to prevent any cookies being placed on your device, but you may then have to manually adjust some preferences every time you visit a site/page. If you do this some services and functionalities may not work properly at all. As the ways by which you can refuse cookies through your web browser controls may vary from browser to browser, you should visit your browser's help menu for more information.
    </p>
    <p className="medium-text space-bottom-double" style={{ marginBottom: '10px' }}>
      Third-party providers that are displaying content on our Website via third-party cookies may at any time change their terms of service, cookie policies and other policies. To control the use of these cookies, you will need to contact the owner of that cookie, which would be the third-party provider.
    </p>
    <div style={{ fontSize: '20px', marginBottom: '10px', fontFamily: 'gt_walsheim' }}>How long will cookies stay on my device?</div>
    <p className="medium-text space-bottom-double" style={{ marginBottom: '10px' }}>
      The length of time a cookie will stay on your computer or mobile device depends on whether it is a "persistent" or "session" cookie.
      <b>
        &nbsp;Persistent cookies&nbsp;
      </b>
      are cookies saved on your computer that are not deleted automatically when you quit your browser, unlike a
      <b>
        &nbsp;session cookie&nbsp;
      </b>
      , which is deleted when you quit your browser. For each of the cookies used on our Website we have set out the duration in the tables below.
    </p>
    <div style={{ fontSize: '20px', marginBottom: '10px', fontFamily: 'gt_walsheim' }}>Cookies used by the Website</div>
    <p className="medium-text space-bottom-double" style={{ marginBottom: '10px' }}>
      The specific types of cookies used by our Website, their duration and the purposes they perform are described in the tables below:
    </p>
    <br />
    <div style={{ fontSize: '20px', marginBottom: '10px', fontFamily: 'gt_walsheim' }}>Strictly necessary cookies:</div>
    <table className="cookie-policy">
      <thead>
        <tr>
          <th>Cookie name and domain</th>
          <th>Type of cookie</th>
          <th>Purpose / Description</th>
          <th>Duration</th>
          <th>Further information</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            OptanonConsent
            travelportmarketplace.com
          </td>
          <td>First-party cookie</td>
          <td>This cookie is set by the cookie compliance solution from OneTrust. It stores information about the categories of cookies the site uses and whether visitors have given or withdrawn consent for the use of each category.</td>
          <td>365 Days</td>
          <td>
            The cookie management tool used for the Website is powered by OneTrust.
            <br />
            <a href="https://www.onetrust.com/cookie-policy/" target="_blank" rel="noreferrer" style={{ textDecoration: 'underline', color: '#337ab7' }}>https://www.onetrust.com/cookie-policy/</a>
          </td>
        </tr>
        <tr>
          <td>
            OptanonAlertBoxClosed
            travelportmarketplace.com
          </td>
          <td>First party cookie</td>
          <td>This cookie is set because Travelport Marketplace website is using the cookie compliance solution from OneTrust. It is set after visitors have seen a cookie information notice and in some cases only when they actively close the notice down. It enables Travelport Marketplace website not to show the message more than once to a user.</td>
          <td>365 Days</td>
          <td>
            The cookie management tool used for the Website is powered by OneTrust.
            <br />
            <a href="https://www.onetrust.com/cookie-policy/" target="_blank" rel="noreferrer" style={{ textDecoration: 'underline', color: '#337ab7' }}>https://www.onetrust.com/cookie-policy/</a>
          </td>
        </tr>
        <tr>
          <td>
            connect.sid
            travelportmarketplace.com
          </td>
          <td>First party cookie</td>
          <td>This cookie is used for authenticating the users when they login on to our website, by maintaining user sessions to access the page after login</td>
          <td>Session cookie (this cookie expires at the end of the user’s browser session)</td>
          <td>&nbsp;</td>
        </tr>
      </tbody>
    </table>
    <br />
    <br />
    <div style={{ fontSize: '20px', marginBottom: '10px', fontFamily: 'gt_walsheim' }}>Analytical / performance cookies:</div>
    <table>
      <thead>
        <tr>
          <th>Cookie name and domain</th>
          <th>Type of cookie</th>
          <th>Purpose / Description</th>
          <th>Duration</th>
          <th>Further information</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            fs_uid
            travelportmarketplace.com
          </td>
          <td>First party cookie</td>
          <td>This cookie is associated with FullStory, which is a tool that captures user interactions on a website for analytics and user experience improvement purposes.</td>
          <td>1 year</td>
          <td>
            <a href="https://www.fullstory.com/legal/privacy-policy/" target="_blank" rel="noreferrer" style={{ textDecoration: 'underline', color: '#337ab7' }}>https://www.fullstory.com/legal/privacy-policy/</a>
          </td>
        </tr>
        <tr>
          <td>
            fs_lua
            travelportmarketplace.com
          </td>
          <td>First party cookie</td>
          <td>This cookie name is associated with FullStory which is used to capture the timestamp of the last user action, assist with the FullStory session lifecycle, collect data on the user's navigation and behavior on the website, and compile statistical reports and heatmaps for the website owner.</td>
          <td>a few seconds</td>
          <td>
            <a href="https://www.fullstory.com/legal/privacy-policy/" target="_blank" rel="noreferrer" style={{ textDecoration: 'underline', color: '#337ab7' }}>https://www.fullstory.com/legal/privacy-policy/</a>
          </td>
        </tr>
        <tr>
          <td>
            ai_session
            travelportmarketplace.com
          </td>
          <td>First party cookie</td>
          <td>This cookie name is associated with the Microsoft Application Insights software, which collects statistical usage and telemetry information for apps built on the Azure cloud platform. This is a unique anonymous session identifier cookie.</td>
          <td>A few seconds</td>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>
            ai_user
            travelportmarketplace.com
          </td>
          <td>First -party cookie</td>
          <td>This cookie name is associated with the Microsoft Application Insights software, which collects statistical usage and telemetry information for apps built on the Azure cloud platform. This is a unique user identifier cookie enabling counting of the number of users accessing the application over time.</td>
          <td>1 year</td>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>
            _splunk_rum_sid
            travelportmarketplace.com
          </td>
          <td>First -party cookie</td>
          <td>This cookie is used by Splunk's Real User Monitoring (RUM) for browsers to store a unique session ID for each user.  This cookie allows Splunk to track a user's session and analyze their activity, enabling us to troubleshoot and monitor user experience. </td>
          <td>A few seconds</td>
          <td>&nbsp;</td>
        </tr>
      </tbody>
    </table>
    <br />
    <div style={{ fontSize: '20px', marginBottom: '10px', fontFamily: 'gt_walsheim' }}>Contact Us</div>
    <p className="medium-text space-bottom-double" style={{ marginBottom: '10px' }}>
      If you have any questions about our use of cookies, please contact our Data Protection Officer at
      <a href="#" target="_blank" rel="noreferrer" style={{ textDecoration: 'underline', color: '#337ab7' }}>&nbsp;privacy@travelport.com&nbsp;</a>
      or our Legal Department at the addresses specified below:
    </p>
    <p className="medium-text space-bottom-double" style={{ marginBottom: '10px' }}>
      Travelport
      <br />
      One Axis Park, 10 Hurricane Way
      <br />
      Langley, Berkshire SL3 8AG
      <br />
      United Kingdom
      <br />
      Attention: Legal Department
      <br />
      T: +44 (0) 1753 288000
      <br />
      F: +44 (0) 1753 288001
      <br />
      <br />
      OR
      <br />
      <br />
      Travelport
      <br />
      300 Galleria Parkway
      <br />
      Atlanta, Georgia 30039
      <br />
      United States of America
      <br />
      Attention: Legal Department
      <br />
      T: +1 770 563 7400
      <br />
      F: +1 770 563 7878
      <br />
    </p>
    <div style={{ fontSize: '20px', marginBottom: '10px', fontFamily: 'gt_walsheim' }}>Updates to the Cookie Policy</div>
    <p className="medium-text space-bottom-double" style={{ marginBottom: '10px' }}>
      We may update this Cookie Policy from time to time to reflect changes to the cookies we use or for other operational, legal, or regulatory reasons. Please therefore revisit this Cookie Policy regularly to stay informed about our use of cookies and related technologies.
    </p>
    <div style={{ fontSize: '20px', marginBottom: '10px', fontFamily: 'gt_walsheim' }}>Effective Date: December 06, 2025</div>
  </div>
);

export default CookiePolicy;
